import create from 'zustand'
import { devtools } from 'zustand/middleware'
import { findBatch, range } from '../utils';
import { DateTime } from 'luxon'
import immer from "./immer"
let useFilesViewStore = (set, get) => ({
    subjects: [],
    files: [],
    faculties: {},
    loading: true,
    setLoading: (a) => set(state => void (state.loading = a)),
    degree: {},
    branch: {},
    options: {
        category: null,
        exam: null,
        batch: null
    },
    setOptions: (data) => set((state) => {
        state.category = data.category || {};
        state.exam = data.exam || {};
        state.batch = data.batch || {};
    }),
    getFaculties: (subject) => {
        if (!subject || subject === null) {
            return [];
        }
        const faculties = get().faculties;
        console.log("Rendered faculties...");
        const none = {
            _id: "none",
            name: "NONE"
        };
        const fac = [];
        console.log(JSON.stringify(faculties, null, 4));
        Object.values(faculties).forEach(f => {
            if (f.subjects.includes(subject)) {
                fac.push(f);
            }
        });
        return fac;
    },
    getSubjects: () => {
        console.log('Rendering subjects...');
        const a = get().subjects;
        return a;
        // return [{ _id: "none", name: "NONE" }, ...a];
    },
    addAll: (data) => set((state) => {
        console.log(data);
        const subjects = {};
        const faculties = {};
        for (const file of data.files) {
            subjects[file.subject._id] = file.subject;
            if (faculties[file.author.user._id]) {
                faculties[file.author.user._id].name = file.author.firstName + file.author.lastName;
                faculties[file.author.user._id].email = file.author.email;
                faculties[file.author.user._id].img = file.author.user.profilePhoto;
                file.sections.forEach(section => {
                    faculties[file.author.user._id].sections[section._id] = section;
                });
                // faculties[file.author.user._id].sections[file.section._id] = file.section;
                faculties[file.author.user._id].total += 1;
                faculties[file.author.user._id].subjects.push(file.subject._id);
                faculties[file.author.user._id].totalSize += parseInt(file.size || '0');
                const prevDate = DateTime.fromISO(faculties[file.author.user._id].latestUpdated);
                const newDate = DateTime.fromISO(file.updatedAt);
                if (prevDate < newDate) {
                    faculties[file.author.user._id].updatedAt = file.updatedAt;
                }
                continue;
            }
            faculties[file.author.user._id] = {
                total: 1,
                name: file.author.firstName + file.author.lastName,
                email: file.author.email,
                img: file.author.user.profilePhoto,
                sections: {},
                latestUpdated: file.updatedAt,
                subjects: [],
                totalSize: parseInt(file.size || '0')
            }
            file.sections.forEach(section => {
                faculties[file.author.user._id].sections[section._id] = section;
            });
            faculties[file.author.user._id].subjects.push(file.subject._id);
        }
        state.faculties = faculties;
        state.subjects = Object.values(subjects);
        state.files = data.files;
        state.degree = data.degree;
        state.branch = data.branch;
        state.loading = false;
    })
});
useFilesViewStore = devtools(useFilesViewStore, { name: "filesView" });
useFilesViewStore = immer(useFilesViewStore);
export default create(useFilesViewStore);
